export default "__VITE_ASSET__Or0jVoG7__"